<!-- Join Our Email List Section -->
<section class=" text-white pb-0 mb-0 email-signup-section " *ngIf="emaildata?.length > 0" [ngClass]="themeClass('subscribe-section1')">
 <div class="top-margin container">
        <div class="row align-items-center join-email-row">
            <div class="col-md-1 us-col-ss"></div>
            <div class="col-12 col-lg-6 d-flex align-items-start align-items-md-center justify-content-center mb-2 mb-md-0"
                [ngClass]="themeClass('subscribe-section2')">
                <div class="email-icon me-sm-2 me-md-5 desktop-img ">
                    <img [src]="cdnImagePath + index9?.actual_image" [alt]="index9?.title"
                        loading="lazy" alt="messageImage" />
                </div>
                <div class="email-icon me-sm-2 me-md-5 d-md-none">
                    <img [src]="cdnImagePath + index9?.secondary_image" [alt]="index9?.title"
                        loading="lazy" alt="messageImage" />
                </div>
                <div class="join-mail-wrap" >
                    <h5 class="mb-1">{{index9?.title ||''}}</h5>
                    <p class="mb-0 para-email" [innerHTML]="index9?.short_description || ''"></p>
                </div>
            </div>
            <div class=" col-12 col-lg-5 mb-3 mb-lg-0 input-wrapper"[ngClass]="themeClass('subscribe-section3')">
                <form [formGroup]="emailForm" (ngSubmit)="onSubmit.emit()">
                    <div class="input-group">
                        <input type="email" class="form-control" placeholder="Enter Email" aria-label="Email"
                            formControlName="email" />
                        <button class="btn btn-subscribe" type="submit" *ngIf=" !chTheme4 && !chTheme6 && !chTheme7 && !chTheme9 && !chTheme10 && !chTheme12">
                            <span class="d-none d-sm-inline">Subscribe ></span>
                            <img [src]="commonImagePath+subscribeButtonArrow" alt="forward-img"
                                class="d-inline d-sm-none hiden-tabs">
                        </button>
                        
                        <button  *ngIf=" chTheme4 || chTheme6 || chTheme7 || chTheme9 || chTheme10 || chTheme12" class="red-tires-btn position-absolute top-50 end-0 translate-middle-y me-1  mt-md-1 mt-lg-1 mt-xl-0"
                                type="submit">
                                <img [src]="commonImagePath+subscribeButtonArrow" class="img-fluid">
                        </button>
                    </div>
                </form>
                <div class="error-msg" *ngIf="errorMessage">
                    {{ errorMessage }}
                </div>
            </div>
            <div class="col-md-1"></div>
        </div>
    </div>
</section>
<hr *ngIf=chTheme12>